import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { ItemBase } from '../../../models/item/item-base';
import { FormImgService } from '../img/img.service';
import { ColumnService } from '../column/column.service';
var FormLabelDirective = /** @class */ (function () {
    function FormLabelDirective(el, renderer, imgService, colService) {
        this.el = el;
        this.renderer = renderer;
        this.imgService = imgService;
        this.colService = colService;
    }
    FormLabelDirective.prototype.ngOnInit = function () {
    };
    FormLabelDirective.prototype.ngOnChanges = function (changes) {
        if (changes.col) {
            this.setDesign();
        }
    };
    FormLabelDirective.prototype.setDesign = function () {
        var design = (this.col.params && this.col.params.design ? this.col.params.design : {});
        var d;
        if (this.colService.checkVal(this.val) && typeof design[this.val] !== 'undefined') {
            d = design[this.val];
        }
        else if (typeof design['$default'] !== 'undefined') {
            d = design['$default'];
        }
        else {
            return;
        }
        if (typeof d.backgroundColor !== 'undefined') {
            this.renderer.setStyle(this.el.nativeElement, 'background-color', d.backgroundColor);
            this.renderer.setStyle(this.el.nativeElement, 'padding', '2px 5px');
        }
        if (typeof d.color !== 'undefined') {
            this.renderer.setStyle(this.el.nativeElement, 'color', d.color);
        }
        if (typeof d.image !== 'undefined') {
            if (d.image) {
                var img = this.renderer.createElement('img');
                this.renderer.setAttribute(img, 'src', this.imgService.host + d.image + this.imgService.updateCacheInvalidate());
                this.renderer.setStyle(img, 'height', '12px');
                this.renderer.appendChild(this.el.nativeElement.parentNode, img);
            }
            this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
        }
    };
    FormLabelDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[formlabelDir]'
                },] }
    ];
    /** @nocollapse */
    FormLabelDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: FormImgService },
        { type: ColumnService }
    ]; };
    FormLabelDirective.propDecorators = {
        col: [{ type: Input }],
        val: [{ type: Input }]
    };
    return FormLabelDirective;
}());
export { FormLabelDirective };
var Design = /** @class */ (function () {
    function Design() {
    }
    return Design;
}());
//# sourceMappingURL=label.directive.js.map